module.exports = __webpack_public_path__ + "media/images/icon__locked@3x-7c625aaff95f210aa797f65c8f512b8a.png";